import AddActionButton from '@components/AddActionButton';
import { FlexRow } from '@components/FlexRow';
import { useState } from 'react';
import { SectionCard } from '../SectionCard';
import { SectionTitle } from '../SectionTitle';
import LanguageFormContainer from './components/LanguageFormContainer';
import LanguageListContainer from './components/LanguageListContainer';
import { TalentLanguage } from './types';

interface LanguageFormProps {
    talentLanguages: TalentLanguage[];
    onSuccess?: () => void;
    onBack?: () => void;
}

const LanguageForm = ({ talentLanguages, onSuccess, onBack }: LanguageFormProps) => {
    const [selectedData, setSelectedData] = useState<TalentLanguage | null>(null);
    const [openForm, setOpenForm] = useState(false);

    const handleAdd = () => {
        setSelectedData(null);
        setOpenForm(true);
    };

    const handleEdit = (item: TalentLanguage) => {
        setSelectedData(item);
        setOpenForm(true);
    };

    const listView = (
        <LanguageListContainer
            talentLanguages={talentLanguages}
            onEdit={handleEdit}
            onSuccess={onSuccess}
            onBack={onBack}
        />
    );

    const formView = (
        <LanguageFormContainer
            key={selectedData?._id ?? 'new'}
            setOpenForm={setOpenForm}
            selectedData={selectedData}
            setSelectedData={setSelectedData}
        />
    );

    if (openForm) {
        return formView;
    }

    return (
        <SectionCard sx={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
            <FlexRow gap={1} alignItems="center" justifyContent="space-between">
                <SectionTitle title="Langue" withInfo />
                <AddActionButton
                    onClick={handleAdd}
                />
            </FlexRow>
            {listView}
        </SectionCard>
    );
};

export default LanguageForm;
